import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { roseColor, primaryColor } from "assets/jss/material-dashboard-pro-react.jsx";

const COLOR_MAP = {
  rose: roseColor,
  primary: primaryColor,
  info: "#00acc1",
  success: "#4caf50",
  warning: "#ff9800",
  danger: "#f44336"
};

const styles = {
  root: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    borderBottom: "2px solid #f0f0f0",
    marginBottom: "16px",
    paddingBottom: "0",
    flexWrap: "wrap",
    gap: "8px"
  },
  tabsRoot: {
    minHeight: "40px",
    flex: 1
  },
  tabRoot: {
    minHeight: "40px",
    minWidth: "80px",
    maxWidth: "200px",
    padding: "6px 16px",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    color: "#9e9e9e",
    opacity: 1,
    "&:hover": {
      color: "#555",
      opacity: 1
    }
  },
  tabSelected: {},
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexShrink: 0,
    paddingBottom: "4px"
  }
};

function ViewToolbar({ classes, tabs, activeTab, onTabChange, actions, color }) {
  const indicatorColor = COLOR_MAP[color] || roseColor;

  return (
    <div className={classes.root}>
      {tabs && tabs.length > 0 ? (
        <Tabs
          value={activeTab || 0}
          onChange={(_, v) => onTabChange && onTabChange(v)}
          classes={{ root: classes.tabsRoot }}
          TabIndicatorProps={{
            style: { backgroundColor: indicatorColor, height: "3px", borderRadius: "3px 3px 0 0" }
          }}
        >
          {tabs.map((tab, i) => {
            const label = typeof tab === "string" ? tab : tab.label;
            const Icon = typeof tab === "object" && tab.icon ? tab.icon : null;
            return (
              <Tab
                key={i}
                label={label}
                icon={Icon ? <Icon style={{ fontSize: "15px", marginBottom: "2px" }} /> : undefined}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
                style={activeTab === i ? { color: indicatorColor } : {}}
              />
            );
          })}
        </Tabs>
      ) : (
        <div style={{ flex: 1 }} />
      )}

      {actions && actions.length > 0 && (
        <div className={classes.actions}>
          {actions.map((action, i) => (
            <React.Fragment key={i}>{action}</React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

ViewToolbar.defaultProps = {
  tabs: [],
  activeTab: 0,
  color: "primary"
};

ViewToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ label: PropTypes.string, icon: PropTypes.func })
    ])
  ),
  activeTab: PropTypes.number,
  onTabChange: PropTypes.func,
  actions: PropTypes.arrayOf(PropTypes.node),
  color: PropTypes.oneOf(["rose", "primary", "info", "success", "warning", "danger"])
};

export default withStyles(styles)(ViewToolbar);
